import config from '../config'
export const wxAuth = (nowUrl) => {
    if (sessionStorage.getItem('mgmInit') != "true") {
        sessionStorage.setItem("mgmInit", "true");
        var u = window.navigator.userAgent;
        // var urlParam = this.$route.query
        if (u.match(/MicroMessenger/i) == 'MicroMessenger') {
            // alert('weixin')
            //微信授权
            var location = window.location;
            // 包括index.html window.location.protocol+'//'+window.location.host+window.location.pathname+'#/mgmshare'
            var tUrl = window.location.href;
            tUrl = encodeURIComponent(tUrl);

            setTimeout(() => {
                //测试 wxf5321627be19a949
                //线上 wxdad0c66adc60a191
                var nowAppid = ''
                switch (config.ENV) {
                    case '-test':
                        nowAppid = 'wxf7bd7e8d3f2ef24a';
                        break
                    case '-uat':
                        nowAppid = 'wxf7bd7e8d3f2ef24a';
                        break
                    case '':
                        nowAppid = 'wxdad0c66adc60a191';
                        break
                }
                window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + nowAppid + '&redirect_uri=' + tUrl + '&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect';
            }, 0)
        }

    }
}



// WEBPACK FOOTER //
// ./src/utils/wxauth.js